import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { AUTH, BASE_URL } from '../../../config/axios';
import { AddwithWhiteCircle, UpdatePencil } from '../../AllSvg';
import { handleErrorToast, ProgressModal } from '../../CustomFunctions';
import { toast } from "react-toastify";


const AddDivision = ({ getdivision }) => {
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [subCompany, setSubCompany] = useState([]);

  const [formData, setFormData] = useState({
    subcompany: '',
    division_name: '',
    address: "",
    mobile_name: "",
    gst_number: "",

  });

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setFormData({
      subcompany: '',
      division_name: '',
      address: "",
      mobile_name: "",
      gst_number: "",
    })
    setErrors({})
    setShow(false);
  }
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateform = () => {
    const newErrors = {};
    const requiredFields = ["subcompany", "division_name", "mobile_name"];

    requiredFields.forEach((field) => {
      if (!formData[field]?.trim()) {
        newErrors[field] = `This field is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateform()) {
      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Loading: Please wait...");
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);
      try {

        const res = await axios.post(`${BASE_URL}/dpr/division/`, formData);

        if (res.status === 201 || res.status === 200) {
          handleClose();
          getdivision(); setTimeout(() => {
            toast.dismiss(loadingToastId);
            toast.success("Data Added successfully.");
          }, 1000);
        } else {
          throw new Error("Unexpected response status: " + res.status);
        }

      } catch (err) {
        clearInterval(interval);
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        clearInterval(interval);

        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);

        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  const fetchSubcompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/dpr/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch sub-companies.");
    }
  };

  useEffect(() => {
    fetchSubcompany();
  }, []);

  return (
    <>
      <button
        title="Add SubCompany"
        className="upload-svg"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> SubCompany
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="add" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="request-leave"
            >
              <Modal.Header
                closeButton
                className="justify-center task-Tab-heading font-weight500 font-size-heading"
              >
                <Modal.Title>Add SubCompany</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <form className="add-activity" onSubmit={handleFormSubmit}>
                  <div className="parent-div">
                    <div className="form-flex-wrap">

                      {/* Sub-Company Dropdown */}
                      <div className="flex-column ">
                        <label className="form-labels">
                          Select Company <span className="required">*</span>
                        </label>

                        {subCompany.length === 0 ? (
                          <div className="form-loader">
                            <div className="bar-loader" style={{ width: '46.5%' }}></div>
                          </div>
                        ) : (
                          <>
                            <select
                              id="subcompany"
                              name="subcompany"
                              style={{ width: "15vw" }}
                              value={formData.subcompany}
                              onChange={handleInputChange}
                              className={`form-input form-group-selection ${errors.subcompany ? "error" : ""}`}
                            >
                              <option value="">Select a Company</option>
                              {subCompany
                                ?.sort((a, b) =>
                                  a?.company_name?.localeCompare(b.company_name, "en", {
                                    ignorePunctuation: true,
                                  })
                                )
                                .map((i) => (
                                  <option key={i.id} value={i.id}>
                                    {i.company_name}
                                  </option>
                                ))}
                            </select>



                            {errors.subcompany && (
                              <span className="error-message font-size-text">
                                {errors.subcompany}
                              </span>
                            )}
                          </>
                        )}
                      </div>

                      {/* Division Name Input */}
                      <div title="Sub Company Name" className="flex-column">
                        <label
                          htmlFor="division_name"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          Sub Company Name<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          maxLength={100}
                          style={{ width: "15vw" }}
                          id="division_name"
                          name="division_name"
                          placeholder="Enter Sub Company name"
                          onChange={handleInputChange}
                          value={formData.division_name}
                          className={`form-input ${errors.division_name ? "input-error" : ""}`}

                        />
                        {errors.division_name && (
                          <span className="error-message font-size-text">
                            {errors.division_name}
                          </span>
                        )}
                      </div>
                      <div title="GST Number" className="flex-column">
                        <label
                          htmlFor="gst_number"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          GST Number
                        </label>
                        <input
                          type="text"
                          maxLength={100}
                          id="gst_number"
                          style={{ width: "15vw" }}
                          name="gst_number"
                          placeholder="Enter GST number"
                          onChange={handleInputChange}
                          value={formData.gst_number}
                          className={`form-input ${errors.gst_number ? "input-error" : ""}`}

                        />
                        {errors.gst_number && (
                          <span className="error-message font-size-text">
                            {errors.gst_number}
                          </span>
                        )}
                      </div>
                      <div title="Mobile Name" className="flex-column">
                        <label
                          htmlFor="mobile_name"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          Mobile Number<span className="required">*</span>
                        </label>
                        <input
                          type="number"
                          maxLength={100}
                          id="mobile_name"
                          name="mobile_name"
                          style={{ width: "15vw" }}
                          placeholder="Enter Mobile name"
                          onChange={handleInputChange}
                          value={formData.mobile_name}
                          className={`form-input ${errors.mobile_name ? "input-error" : ""}`}

                        />
                        {errors.mobile_name && (
                          <span className="error-message font-size-text">
                            {errors.mobile_name}
                          </span>
                        )}
                      </div>
                      <div title="Address" className="flex-column">
                        <label
                          htmlFor="address"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          Address<span className="required">*</span>
                        </label>
                        <textarea
                          type="text"
                          maxLength={100}
                          id="address"
                          name="address"
                          placeholder="Enter Address"
                          onChange={handleInputChange}
                          value={formData.address}
                          className={`form-input-textarea ${errors.address ? "input-error" : ""}`}

                        />
                        {errors.address && (
                          <span className="error-message font-size-text">
                            {errors.address}
                          </span>
                        )}
                      </div>

                      {/* Submit Button */}
                      <div className="button-models" style={{ width: '100%' }}>
                        <button
                          type="submit"
                          className="model-button font-weight500 model-button-submit"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};
const UpdateDivison = ({ i, getdivision }) => {
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [subCompany, setSubCompany] = useState([]);

  const [formData, setFormData] = useState({
    subcompany: '',
    division_name: '',
    address: "",
    mobile_name: "",
    gst_number: "",

  });

  const handleShow = () => {
    setShow(true);
    setFormData(i);
  }
  const handleClose = () => {
    setFormData({
      subcompany: '',
      division_name: '',
      address: "",
      mobile_name: "",
      gst_number: "",
    })
    setErrors({})
    setShow(false);
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateform = () => {
    const newErrors = {};
    const requiredFields = ["subcompany", "division_name", "mobile_name"];


    requiredFields.forEach((field) => {
      if (!formData[field]?.trim()) {
        newErrors[field] = `This field is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [loading, setLoading] = useState(false);


  const handleFormSubmit = async (e) => {
    e.preventDefault();


    if (validateform()) {
      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Loading: Please wait...");
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);

      try {


        const res = await axios.put(`${BASE_URL}/dpr/division/${i.id}/`, formData, AUTH());
        ;

        if (res.status === 201 || res.status === 200) {

          handleClose();
          await getdivision();

          setTimeout(() => {
            toast.dismiss(loadingToastId);
            toast.success("Data Updated successfully.");
          }, 1000);
        } else {
          throw new Error("Unexpected response status: " + res.status);
        }

      } catch (err) {
        clearInterval(interval);
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        clearInterval(interval);

        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);

        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  const fetchSubcompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/dpr/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch companies.");
    }
  };

  useEffect(() => {
    fetchSubcompany();
  }, []);

  return (
    <>
      <button
        title="Update SubCompany"
        className="model-edit-button"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="request-leave"
            >
              <Modal.Header
                closeButton
                className="justify-center task-Tab-heading font-weight500 font-size-heading"
              >
                <Modal.Title>Update SubCompany</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <form className="add-activity" onSubmit={handleFormSubmit}>
                  <div className="parent-div">
                    <div className="form-flex-wrap">

                      {/* Sub-Company Dropdown */}
                      <div className="flex-column ">
                        <label className="form-labels font-weight500 font-size-subheading">
                          Select Company <span className="required">*</span>
                        </label>

                        {subCompany.length === 0 ? (
                          <div className="form-loader">
                            <div className="bar-loader" style={{ width: '46.5%' }}></div>
                          </div>
                        ) : (
                          <>
                            <select
                              id="subcompany"
                              name="subcompany"
                              style={{ width: "15vw" }}
                              value={formData.subcompany}
                              onChange={handleInputChange}
                              className={`form-input form-group-selection ${errors.subcompany ? "error" : ""}`}
                            >
                              <option value="">Select a Company</option>
                              {subCompany
                                ?.sort((a, b) =>
                                  a?.company_name?.localeCompare(b.company_name, "en", {
                                    ignorePunctuation: true,
                                  })
                                )
                                .map((i) => (
                                  <option key={i.id} value={i.id}>
                                    {i.company_name}
                                  </option>
                                ))}
                            </select>



                            {errors.subcompany && (
                              <span className="error-message font-size-text">
                                {errors.subcompany}
                              </span>
                            )}
                          </>
                        )}
                      </div>

                      {/* Division Name Input */}
                      <div title="Sub Company Name" className="flex-column">
                        <label
                          htmlFor="division_name"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          Sub Company Name<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          maxLength={100}
                          style={{ width: "15vw" }}
                          id="division_name"
                          name="division_name"
                          placeholder="Enter Sub Company name"
                          onChange={handleInputChange}
                          value={formData.division_name}
                          className={`form-input ${errors.division_name ? "input-error" : ""}`}

                        />
                        {errors.division_name && (
                          <span className="error-message font-size-text">
                            {errors.division_name}
                          </span>
                        )}
                      </div>
                      <div title="GST Number" className="flex-column">
                        <label
                          htmlFor="gst_number"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          GST Number
                        </label>
                        <input
                          type="text"
                          maxLength={100}
                          id="gst_number"
                          style={{ width: "15vw" }}
                          name="gst_number"
                          placeholder="Enter GST number"
                          onChange={handleInputChange}
                          value={formData.gst_number}
                          className={`form-input ${errors.gst_number ? "input-error" : ""}`}

                        />
                        {errors.gst_number && (
                          <span className="error-message font-size-text">
                            {errors.gst_number}
                          </span>
                        )}
                      </div>
                      <div title="Mobile Name" className="flex-column">
                        <label
                          htmlFor="mobile_name"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          Mobile Number<span className="required">*</span>
                        </label>
                        <input
                          type="number"
                          maxLength={100}
                          id="mobile_name"
                          name="mobile_name"
                          style={{ width: "15vw" }}
                          placeholder="Enter Mobile name"
                          onChange={handleInputChange}
                          value={formData.mobile_name}
                          className={`form-input ${errors.mobile_name ? "input-error" : ""}`}

                        />
                        {errors.mobile_name && (
                          <span className="error-message font-size-text">
                            {errors.mobile_name}
                          </span>
                        )}
                      </div>
                      <div title="Address" className="flex-column">
                        <label
                          htmlFor="address"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          Address
                        </label>
                        <textarea
                          type="text"
                          maxLength={100}
                          id="address"
                          name="address"
                          placeholder="Enter Address"
                          onChange={handleInputChange}
                          value={formData.address}
                          className={`form-input-textarea ${errors.address ? "input-error" : ""}`}

                        />
                        {errors.address && (
                          <span className="error-message font-size-text">
                            {errors.address}
                          </span>
                        )}
                      </div>

                      {/* Submit Button */}
                      <div className="button-models" style={{ width: '100%' }}>
                        <button
                          type="submit"
                          className="model-button font-weight500 model-button-submit"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};

const DeleteDivision = ({ i, getdivision }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(true)
  }

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      let res = await axios.delete(
        `${BASE_URL}/dpr/division/${i.id}/`
      );

      if (res.status === 200) {
        toast.success(`Data deleted successfully`);
        await getdivision();
        setShow(false);
      }
    } catch (err) {
      toast.error("Failed to delete data");
      console.error(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete SubCompany"
        className="model-delete-button"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Delete SubCompany: {i.division_name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to delete{" "}
            <strong>{i.division_name}</strong>?
          </p>
          <div className="button-models">
            <button
              className="model-button model-button-cancel"
              onClick={() => setShow(false)}
            >
              Cancel
            </button>
            <button
              onClick={handleFormSubmitDelete}
              className="model-button model-button-delete"
            >
              Delete
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export { AddDivision, DeleteDivision, UpdateDivison };
